



import {Component, Prop, Vue} from 'vue-property-decorator';
import RecentSearch from "@/components/Molecules/RecentSearch/RecentSearch.vue";
import CheckInputQuestion from "@/components/Atoms/CheckInputQuestion/CheckInputQuestion.vue";
import {TutorialModel} from "@/share";

@Component({
  components: {RecentSearch, CheckInputQuestion}
})
export default class Tutorial extends Vue {
  @Prop({required: false, type: Number, default: 2}) tutorialStep!: number
  @Prop({required: false, type: Object}) category!: any
  @Prop() tutorials!: TutorialModel[]

  private get stepTutorial() {
    return this.category.type
  }

  private get questionTutorial() {
    return this.category.question
  }

  private get tutorialActive(): any {
    return (type: number) => {
      return type == this.category.key
    }
  }

  private onChangeCheckbox(status: number, value: number) {
    this.$emit('onChange', status, value)
  }
}
